<script setup lang="ts">
// globals
defineProps({
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <v-progress-linear
    color="primary"
    indeterminate
  />
  <div class="text-h6 text-black text-center">
    {{ text }}
  </div>
</template>
